import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { getActiveSupplyPoint } from '@/features/supply-points/utils/resolveActiveSupplyPoint';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton';
import { productQueries } from '@/features/products/queries';
import { ProductsPage } from '@/features/products/pages/ProductsPage';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/products')({
  component: ProductsPage,
  pendingComponent: DetailsPageSkeleton,
  loader: async ({ context: { queryClient } }) => {
    const activeSupplyPoint = await getActiveSupplyPoint(queryClient);

    if (activeSupplyPoint) {
      await Promise.all([
        queryClient.ensureQueryData(productQueries.variants()),
        queryClient.ensureQueryData(productQueries.products(activeSupplyPoint.id)),
      ]);
    }

    return { breadcrumb: t`Products` };
  },
});
